
import React, { useMemo } from "react";
import UrgentBadge from 'components/common/UrgentBadge';
import { useDispatch, useSelector } from "react-redux";
import { Link, Route, Routes } from "react-router-dom";
import Api from "services/api"
import { ListLayout } from "components/common/ListLayout";
import TableHeaderItem from "components/common/ListLayout/TableHeaderItem";
// import { convertTimeToUTC } from "helpers/convertTimeToUTC";
import { setAddAppointmentPopup } from "slices/appointmentSlice";
import AppointmentView from "./appointment/view";
import { vendorAppointmentsSelector } from "slices/vendor/appointmentSlice";
import { fetchVendorAppointments } from "slices/vendor/appointmentSlice";
import { getBackgroundStyle } from "components/common/TableColor";
import { convertTimeToUTCNew } from "helpers/convertTimeToUTC";

const apiService = new Api();

const appointmentRoutes = [
  {
    path: "",
    component: <AppointmentList />,
  },
  {
    path: "view/:id",
    component: <AppointmentView />,
  }
]

export const AppointmentRoutes = () => {

  return (
    <Routes>
      {appointmentRoutes.map(({ path, component }) => (
        <Route key={path} path={path} element={component} />
      ))}
    </Routes>
  )

}

function AppointmentList() {
  const dispatch = useDispatch()
  const { vendorAppointments: appointments, last_page: totalPages, loader, total, current_page, per_page: pageLength } = useSelector(vendorAppointmentsSelector);
  const [addForm, setAddForm] = React.useState({
    show: false,
    item: {}

  });
  const refAddutton = React.useRef(null);

  const [selectedItems, setSelectedItems] = React.useState([]);
  const [selectAll, setSelectAll] = React.useState(false);
  const [currentPage, setCurrentPage] = React.useState(1);
  const [searchTerm, setSearchTerm] = React.useState("");
  const [sortConfig, setSortConfig] = React.useState({
    sortBy: 'name',
    sortDirection: 'asc',
  });

  React.useEffect(() => {
    dispatch(fetchVendorAppointments())
  }, [])

  const handleAddAppointmentPopUp = (item) => {
    dispatch(setAddAppointmentPopup({
      show: true,
      item,
    }))
  };

  const handleChange = (e) => {
    const id = e.target.dataset.value
    setSelectedItems(
      selectedItems.includes(id) ?
        selectedItems.filter((item) => item != id) :
        [...selectedItems, id]
    )
  };


  //#region TABLE HEAD 

  const renderTableHeader = React.useCallback(() => {
    const callBack = (dir, sortBy) => {
      setSortConfig({ sortBy, sortDirection: dir })
      dispatch(fetchVendorAppointments(currentPage, { sortBy: sortBy, sortDirection: dir, search: searchTerm }))
    }
    return (
      <tr>
        <th className="col-1">
          <div className="row_check">
            <span>#</span>
          </div>
        </th>
        <th>
          <TableHeaderItem
            title="appid"
            sortBy="appid"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>

        <th>
          <TableHeaderItem
            title="Service"
            sortBy="service"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>

        <th>
          <TableHeaderItem
            title="Date"
            sortBy="date"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>
        <th>
          <TableHeaderItem
            title="Language"
            sortBy="language"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>
        {/* <th>
          <TableHeaderItem
            title="Accounts"
            sortBy="accounts"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th> */}
        <th>
          <TableHeaderItem
            title="Interpreter"
            sortBy="interpreter"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>
        <th>
          <TableHeaderItem
            title="Creation Date"
            sortBy="created_at"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>
        <th className="col-1">
          <TableHeaderItem
            title="Status"
            sortBy="status"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>
      </tr>
    )
  }, [selectAll, searchTerm, sortConfig, currentPage, selectedItems, appointments]);

  //#endregion


  //#region TABLE BODY

  const renderTableContent = React.useCallback(() => {
    return (
      appointments && appointments?.map((appointment, index) => (
        <AppointmentItem appointment={appointment} index={index} selectedItems={selectedItems} handleChange={handleChange} handleAddPopUp={handleAddAppointmentPopUp} current_page={current_page} pageLength={pageLength} />
      ))
    )
  }, [appointments, selectedItems, current_page]);

  //#endregion


  return (
    <ListLayout
      heading="Appointments"
      time={true}
      addButtonDisabled={true}
      title=""
      renderTableHeader={renderTableHeader}
      renderTableContent={renderTableContent}
      totalPages={totalPages}
      fetchList={fetchVendorAppointments}
      selectedItems={selectedItems}
      refAddutton={refAddutton}
      addForm={addForm}
      searchTerm={searchTerm}
      setSearchTerm={setSearchTerm}
      loader={loader}
      searchPlaceholder="Search Appointments ..."
      noOfItems={total}
      refAddPopUp="#addAppointmentPopUp"
    >
    </ListLayout>
  )

}


const AppointmentItem = ({
  appointment, index, current_page, pageLength
}) => {

  const serial = useMemo(() => {
    return index + 1 + (current_page - 1) * pageLength;
  }, [current_page, pageLength]);


  const statuses = [
    {
      label: "Available",
      value: "available",
    },
    {
      label: "Assigned",
      value: "assigned",
    }, {
      label: "DNC",
      value: "dnc",
    },
    {
      label: "CNC",
      value: "cnc",
    },
    {
      label: "Completed",
      value: "completed",
    },
    {
      label: "Cancelled",
      value: "cancelled",
    }
  ]


  return (
    <tr>
      <td style={getBackgroundStyle(appointment?.status)}>
        <div className="row_check">
          <span>{serial}</span>
        </div>
      </td>
      <td style={getBackgroundStyle(appointment?.status)}>
        <Link className='link_preview' to={`/vendor/appointments/view/${appointment?.id}`}>
          {appointment?.appid}
        </Link>
        {appointment?.is_urgent_effective && (
          <div style={{ marginTop: 2 }}><UrgentBadge item={appointment} /></div>
        )}
      </td>
      <td style={getBackgroundStyle(appointment?.status)}>
        {appointment?.type || 'N/A'}
      </td>
      <td style={getBackgroundStyle(appointment?.status)}>
        {appointment?.datetime || 'N/A'}
      </td>
      <td style={getBackgroundStyle(appointment?.status)}>
        {appointment?.language?.name || 'N/A'}
      </td>
      {/* <td style={getBackgroundStyle(appointment?.status)}>
        {appointment?.accounts?.user?.name || 'N/A'}
      </td> */}
      <td style={getBackgroundStyle(appointment?.status)}>
        {appointment?.interpreter?.user?.name || 'N/A'}
      </td>
      <td style={getBackgroundStyle(appointment?.status)}>
        {convertTimeToUTCNew(appointment.created_at)}
      </td>
      <td className="text-capitalize" style={getBackgroundStyle(appointment?.status)}>
        {appointment?.status}
      </td>
    </tr>
  )
}


export default AppointmentList;
